<div
    #toggleButton
    (click)="toggleAll()"
    [ngClass]="{ selected: gridApi.nfAllToggled }"
    class="tSelect tSelectHeader"
    id="RowSelect_Header"
></div>
